import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "create-brand app-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Create Brand")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "Enter brand details", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, "Name:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "Description", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_5,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
          rows: "5",
          cols: "50"
        }, null, 8, ["modelValue"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: _ctx.createButtonIcons,
          label: "Create",
          onClick: _ctx.create,
          disabled: _ctx.loading
        }, null, 8, ["icon", "onClick", "disabled"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          label: "Cancel",
          class: "p-button-secondary",
          style: {"margin-left":".5em"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'brands' })))
        })
      ]),
      _: 1
    })
  ]))
}